import { string } from 'prop-types';

const PlacesIcon = ({ className }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
      <title>place-icon</title>
      <g fill="none">
        <g>
          <g transform="translate(-70 -60) translate(70 60)">
            <circle cx="20" cy="20" r="20" fill="#F2F2F2" />
            <g fill="#428A13">
              <path
                d="M5 13V5h13.233l-2.09 3.485c-.191.317-.191.713 0 1.03L18.233 13H5zm13.166-4l2.691-4.485c.186-.309.191-.694.013-1.008C20.692 3.194 20.36 3 20 3H5V2c0-.552-.447-1-1-1-.553 0-1 .448-1 1v20c0 .552.447 1 1 1 .553 0 1-.448 1-1v-7h15c.36 0 .692-.194.87-.507.178-.314.173-.699-.013-1.008L18.166 9z"
                transform="translate(8 8)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

PlacesIcon.propTypes = {
  className: string
};

PlacesIcon.defaultProps = {
  className: ''
};

export default PlacesIcon;
